const QUERY_CREDIT_ACCOUNT_TRANSACTIONS = `
  query WebCreditAccountTransactions($page: Int, $per_page: Int) {
    me {
      id
      credit_account(page: $page, per_page: $per_page) {
        balance
        referral_amount
        transactions {
          amount
          created_at
          income
          transaction_type
        }
      }
    }
  }
`

const QUERY_CUSTOMER_BALANCE = `
query WebCreditAccountBalance {
  me {
    credit_account {
      balance
    }
  }
}
`

const MUTATION_PURCHASE_OVERDRAFT = `
mutation WebPurchaseOverdraft($input: PurchaseOverdraftInput!) {
  PurchaseOverdraft(input: $input) {
    errors {
      error_code
      message
    }
    order {
      id
      successful
    }
    payment {
      authorization_details
      id
      gateway
    }
  }
}
`
export default {
  QUERY_CUSTOMER_BALANCE,
  QUERY_CREDIT_ACCOUNT_TRANSACTIONS,
  MUTATION_PURCHASE_OVERDRAFT
}
